import script from "./ClassroomItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomItem.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomItem.vue?vue&type=style&index=0&id=9a91b734&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a91b734"]])

export default __exports__